var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedical = function SvgMedical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.142 18.334h7.708a4.06 4.06 0 0 0 4.058-4.059v-7.3a4.06 4.06 0 0 0-4.058-4.058H6.142a4.06 4.06 0 0 0-4.059 4.058v7.292a4.06 4.06 0 0 0 4.059 4.067",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.908 5.242a.624.624 0 0 1-.625-.625V2.292a.624.624 0 1 1 1.25 0v2.317c0 .35-.275.633-.625.633M13.092 5.242a.624.624 0 0 1-.625-.625V2.292a.624.624 0 1 1 1.25 0v2.317c0 .35-.275.633-.625.633M10 12.291H8.592v-1.458a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v1.458H5.833a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625h1.509V15a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625V13.54H10a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625"
  })));
};
export default SvgMedical;